<div class="comming-soon--fullgrid comming-soon--fullgrid--loader">
  <div class="icon--loader">
    <ngx-skeleton-loader
      [theme]="{
        appearance: 'circle',
        width: '100%',
        'border-radius': '0',
        height: '100%',
        'background-color': '#f9f9fa',
      }"
    ></ngx-skeleton-loader>
  </div>
  <div class="content content--loader">
    <div class="content__headline content__headline--loader">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          'margin-bottom': '0',
          'background-color': '#f9f9fa',
        }"
      ></ngx-skeleton-loader>
    </div>
    <div class="content__text content__text--loader">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          'margin-bottom': '0',
          'background-color': '#f9f9fa',
        }"
      ></ngx-skeleton-loader>
    </div>
    <div class="content__buttons--loader">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          'margin-bottom': '0',
          'background-color': '#f9f9fa',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
  <div class="background">
    <ngx-skeleton-loader
      [theme]="{
        width: '100%',
        height: '100%',
        'margin-bottom': '0',
      }"
    ></ngx-skeleton-loader>
  </div>
</div>
